import { SelectOptionElement } from '@odin-labs/components';
import { RequiredField } from 'utils/validation';
import { BriefcaseIcon } from 'components/icons';
import { FormInputTypes, GridColSpan, TypedFormInputs } from 'components/form';

export type AddWorkerCommentFormData = {
  comment: string;
  jobsiteId: SelectOptionElement;
};

export type AddWorkerInputsArgs = {
  jobsitesOptions: SelectOptionElement[];
};

export const getFormInputs = ({
  jobsitesOptions,
}: AddWorkerInputsArgs): TypedFormInputs<AddWorkerCommentFormData> => ({
  comment: {
    element: FormInputTypes.TextAreaField,
    label: 'Do not include any PHI',
    elementProps: {
      placeholder: 'Comment',
      size: 'base',
      autosize: true,
    },
    validation: { required: { value: true, message: RequiredField`Comment` } },
    layout: [GridColSpan.SpanFull],
  },
  jobsiteId: {
    element: FormInputTypes.Select,
    label: 'Jobsite',
    elementProps: {
      placeholder: 'Select jobsite',
      options: jobsitesOptions,
      icon: BriefcaseIcon,
      disabled: (jobsitesOptions?.length ?? 0) < 2,
    },
    validation: { required: true },
    layout: GridColSpan.SpanFull,
  },
});

export const getDefaultValues = (args: {
  jobsitesOptions: SelectOptionElement[];
}): AddWorkerCommentFormData => {
  const { jobsitesOptions } = args;

  return {
    comment: '',
    jobsiteId: jobsitesOptions?.length === 1 ? jobsitesOptions[0] : null,
  };
};
